import { Heading, Stack, Text, BoxProps, Box } from "@chakra-ui/react";
import * as React from "react";

const SubHead: React.FC<{
  title: string;
  sub?: string | React.ReactNode;
  customBottom?: BoxProps["marginBottom"];
  customWidth?: BoxProps["maxWidth"];
}> = ({ title, sub, customBottom, customWidth }) => (
  <Stack spacing="0px" align="center">
    <Stack
      mt={{ base: "60px", sm: "80px" }}
      mb={customBottom || { base: "40px", sm: "60px" }}
      align="center"
      maxW={customWidth || undefined}
    >
      <Heading as="h2" textAlign="center">
        {title}
      </Heading>
      {sub && typeof sub === "string" ? (
        <Text variant="small_2" textAlign="center" pt="20px">
          {sub}
        </Text>
      ) : (
        <Box pt="20px">{sub}</Box>
      )}
    </Stack>
  </Stack>
);

export default SubHead;
